<template>
  <section class="positioner">
    <section
      class="flex justify-between"
      :class="[!gameSettingsState.isLeft ? 'bottom-right' : 'bottom-left']"
      :style="{transform: `scale(${scaleCoef})`}"
    >
      <div
        v-if="!gameSettingsState.isLeft"
        class="fake-space"
      />
      <section class="relative">
        <arrow-animation
          style="position: absolute; width: 580px; height: 460px; bottom: 0;"
          position="bottom"
          :is-scaled="false"
        />
        <mobile-button
          :glow="true"
          :type="'start-biatlon'"
          :is-scaled="false"
          @mousedown.stop=""
          @mouseup.stop=""
          @touchstart.stop="buttonClick()"
          @touchend.stop=""
        />
        <start-efficiency-bar
          :forced-size="100"
          :is-scaled="false"
          :glow="true"
          :is-left="gameSettingsState.isLeft"
        />
      </section>
    </section>
  </section>
</template>

<script lang="ts">
import {
  WindowAspect,
  MobileButton,
  ArrowAnimation,
  gameSettingsState,
  tutorialCoreState
} from '@powerplay/core-minigames-ui'
import { defineComponent } from 'vue'
import StartEfficiencyBar from '@/components/Inputs/StartEfficiencyBar.vue'
import { tutorialFlow } from '@/app/modes/tutorial/TutorialFlow'
import { tutorialManager } from '@powerplay/core-minigames'

export default defineComponent({
  name: 'TutorialButtonStart',
  components: {
    MobileButton,
    StartEfficiencyBar,
    ArrowAnimation
  },
  mixins: [WindowAspect],
  data() {

    return {
      gameSettingsState: gameSettingsState(),
    }

  },
  methods: {
    buttonClick() {

      if (tutorialManager.getTypeWriting()) {

        tutorialCoreState().typeWriter = false
        tutorialManager.setTypeWriting(false)
        return

      }
      tutorialFlow.eventActionPressed()
      tutorialManager.nextSection()

    }
  }
})
</script>

<style scoped lang="less">
.positioner {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.relative {
  position: relative;
}

.power-mobile-button {
    pointer-events: auto;
}

</style>
